import { AddRouteParamArgs } from './types';

export const addRouteParams = ({
  omitOrgSlug,
  omitSiteId,
  orgSlug,
  path,
  siteId,
}: AddRouteParamArgs) => {
  const pathArgs = [];
  if (!omitOrgSlug) {
    pathArgs.push(orgSlug);

    if (!omitSiteId) {
      pathArgs.push(siteId);
    }
  }

  pathArgs.push(path);

  const joinedPath = pathArgs.join('/');

  return `a/${joinedPath}`;
};
